import React from 'react';
import { IconProps } from '.';

const SvgArrowDirectionRight = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='m18.197 11.25-5.688-5.721 1.064-1.058L21.058 12l-7.485 7.529-1.064-1.058 5.688-5.721H3v-1.5h15.197Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgArrowDirectionRight;
